import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { z } from 'zod';
import { CONVERSATION_ATTACHMENTS_PATH_NAME } from './conversation-attachments.constants';
import {
  ConversationAttachmentDeleteResponseSchema,
  ConversationAttachmentsListResponseSchema,
  ConversationAttachmentsUploadBodySchema,
  ConversationAttachmentsUploadResponseSchema,
} from './conversation-attachments.schema';

const ThreadPathParamsSchema = z.object({
  threadId: z.string(),
});

const AttachmentPathParamsSchema = ThreadPathParamsSchema.extend({
  attachmentId: z.string(),
});

export const ConversationAttachmentsContract = terraContract
  .prefix(`/${CONVERSATION_ATTACHMENTS_PATH_NAME}`)
  .router({
    uploadConversationAttachments: terraContract
      .meta({
        permissions: [PERMISSIONS.EXECUTE_TESTS.name],
      })
      .route({
        method: 'POST',
        path: '/conversations/{threadId}/attachments',
        summary: 'Upload session-scoped conversation attachments',
        inputStructure: 'detailed',
      })
      .input(
        z.object({
          params: ThreadPathParamsSchema,
          body: ConversationAttachmentsUploadBodySchema,
        }),
      )
      .output(ConversationAttachmentsUploadResponseSchema),
    listConversationAttachments: terraContract
      .meta({
        permissions: [PERMISSIONS.VIEW_TESTS.name],
      })
      .route({
        method: 'GET',
        path: '/conversations/{threadId}/attachments',
        summary: 'List session-scoped conversation attachments',
        inputStructure: 'detailed',
      })
      .input(z.object({ params: ThreadPathParamsSchema }))
      .output(ConversationAttachmentsListResponseSchema),
    deleteConversationAttachment: terraContract
      .meta({
        permissions: [PERMISSIONS.EXECUTE_TESTS.name],
      })
      .route({
        method: 'DELETE',
        path: '/conversations/{threadId}/attachments/{attachmentId}',
        summary: 'Delete a session-scoped conversation attachment',
        inputStructure: 'detailed',
      })
      .input(z.object({ params: AttachmentPathParamsSchema }))
      .output(ConversationAttachmentDeleteResponseSchema),
  });
